import {
  OEM_ADMIN_SELF_REQUEST,
  OEM_ADMIN_SELF_SUCCESS,
  OEM_ADMIN_SELF_FAILURE,
} from "./OemAdminApplicationListActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export default function OemAdminApplicationListReducer(state = initialState, action) {
  switch (action.type) {
    case OEM_ADMIN_SELF_REQUEST:
      return { ...state, loading: true, error: null };
    case OEM_ADMIN_SELF_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case OEM_ADMIN_SELF_FAILURE:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}